module.exports = __webpack_public_path__ + "img/cta_minimal.ae75f456.png";